export const Urls = {
    reviews: {
        getData: '/api/Reviews',
        getLandingPageData: '/api/Reviews/GetLandingPageData',
        getReputationData: '/api/Reviews/GetReputationReview',
        getGooglePlaceData: '/api/Reviews/GetGoogleReviews',
        getYelpReviewData: '/api/Reviews/GetYelpReviews'
    },
    coupons: {
        getData: 'api/Coupons'
    },
    homeBanner: {
        getData: 'api/Banner/Home'
    },
    homeImage: {
        getData: 'api/Image/Home',
        getGalleryPhotos: 'api/Image/GetGalleryPhotos'
    }
}


// WEBPACK FOOTER //
// ./Src/Shared/Api.js